import AuthHelper from "../../../../common/helpers/AuthHelper";
import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import CustomerService from "../../../../common/services/customer/CustomerService";
import RfpService from "../../../../common/services/rfp/RfpService";
import { SHOW_TOAST_MESSAGE } from "../../../../common/store/actions";
import {
    DELETE_RFPS,
    DUPLICATE_RFPS,
    GET_CUSTOMER_REQUESTS,
} from "../../../rfp/store/actions";
import { DELETE_RFP, GET_CUSTOMER_RFP_QUOTATIONS, EDIT_RFP, GET_OFFERS_KITS, UPDATE_RFP_STATUS } from "./actions";

export default {
    state: {
        requests: [],
        offersKits: [],
    },
    getters: {
        customerRequests: (state) => {
            return state.requests;
        },
        offersKits: (state) =>{
            return state.offersKits;
        }
    },
    mutations: {
        [GET_CUSTOMER_REQUESTS]: (state, data) => {
            state.requests = data;
        },
        [GET_OFFERS_KITS]: (state, data) => {
            
            state.offersKits = data;
            
        },
        [GET_CUSTOMER_RFP_QUOTATIONS]: (state, data) => {
            state.requests.forEach((item) => {
                if (item.id == data.id) item.quotations = data.quotations;
            });
        },
        [DELETE_RFP]: (state, id) => {
            state.requests.forEach((item, index) => {
                if (item.id == id) {
                    state.requests.splice(index, 1);
                    return;
                }
            });
        },
    },
    actions: {
        [GET_CUSTOMER_RFP_QUOTATIONS]: async(context, id) => {
            var rfpService = new RfpService();
            var result = await rfpService.getQuotations1(id);
            context.commit(GET_CUSTOMER_RFP_QUOTATIONS, { id: id, quotations: result.data.data })
            return result;
        },
        [GET_CUSTOMER_REQUESTS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerRequests(
                context.getters.customer.id
            );
            context.commit(GET_CUSTOMER_REQUESTS, results.data.data.data);
        },

        [GET_OFFERS_KITS]: (context, data) => {
       
            context.commit(GET_OFFERS_KITS, data);
            
        },
        
        [DELETE_RFPS]: async(context, ids) => {
            if (!AuthHelper.checkAuthForAction(context)) return await new Promise();
            var rfpService = new RfpService();
            await rfpService
                .deleterfps(ids)
                .then((res) => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(1, "Successfully Deleted !")
                    );

                })
                .catch((e) => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, e)
                    );
                });
        },
        [DUPLICATE_RFPS]: async(context, ids) => {
            if (!AuthHelper.checkAuthForAction(context)) return;
            var rfpService = new RfpService();
            await rfpService
                .duplicaterfps(ids)
                .then((res) => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(1, "Successfully Duplicated !")
                    ).then(() => {
                        context.dispatch(GET_CUSTOMER_REQUESTS);
                    });;
                })
                .catch(() => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, "Something Went Wrong!")
                    );
                });
        },
        [EDIT_RFP]: async(context, rfp) => {
            var rfpService = new RfpService();
            if (!Array.isArray(rfp.budget)) rfp.budget = rfp.budget._value;
            if (!Array.isArray(rfp.year)) rfp.year = rfp.year._value;
            var result = await rfpService
                .edit(rfp).then((result) => {
                    context.dispatch(GET_CUSTOMER_REQUESTS);

                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(1, "Successfully Updated !")
                    );
                })
                .catch(() => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, "Something Went Wrong!")
                    );
                });
            return result;
        },

        // [UPDATE_RFP_STATUS]: async(ids, status_id) => {
        //     var rfpService = new RfpService();
        //     var result = await rfpService.editRfpStatus({ids,status_id});
        //     return result;
        // },
    },
};